import { HttpHeaders } from '@angular/common/http';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,

    /* url do servidor*/
    // url_api: 'http://localhost:8080/evoto',
    // url_front: 'http//localhost:4200',
    url_api: 'https://evoto.sinqia.com.br/evoto',
    url_front: 'https://evoto.sinqia.com.br', //url de produção
    
      /* url do servidor*/
    // url_api: 'https://meufuturo.net.br/evoto',
    httpOptions: {
      headers: new HttpHeaders({ 'Content-Type': 'application/json',
      'X-Content-Type-Options':  'nosniff' })
    }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.